<template>
  <div>
    <b-tabs pills align="left">
      <b-tab title="Add" active>
        <b-card-text>
          <add-sundy />
          <!-- {{ tabData[0]["home"] }} -->
        </b-card-text>
      </b-tab>
      <b-tab title="Adjustment">
        <b-card-text>
          <adjustment />
          <!-- {{ tabData[1]["profile"] }} -->
        </b-card-text>
      </b-tab>
      <b-tab title="Sundy Status">
        <b-card-text>
          <sundy-status />
          <!-- {{ tabData[3]["about"] }} -->
        </b-card-text>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab, BCardText } from "bootstrap-vue";
import addSundy from "@/components/sundyPay/addSundy.vue";
import adjustment from "@/components/sundyPay/adjustment.vue";
import SundyStatus from "../components/sundyPay/sundyStatus.vue";

export default {
  name: "cashPay",
  components: {
    BTabs,
    BTab,
    BCardText,
    SundyStatus,
    addSundy,
    adjustment,
  },
  data() {
    return {
      tabData: [
        {
          home:
            "Candy canes donut chupa chups candy canes lemon drops oat cake wafer. Cotton candy candy canes marzipan carrot cake. Sesame snaps lemon drops candy marzipan donut brownie tootsie roll. Icing croissant bonbon biscuit gummi bears. Pastry gummi bears sweet roll candy canes topping ice cream. Candy canes fruitcake cookie carrot cake pastry.",
        },
        {
          profile:
            "Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit. Dessert toffee fruitcake ice cream powder tootsie roll cake.Pudding candy canes sugar plum cookie chocolate cake powder croissant.",
        },
        { disabled: "lorem" },
        {
          about:
            "Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit. Dessert toffee fruitcake ice cream powder tootsie roll cake.Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit.",
        },
      ],
    };
  },
};
</script>